import { render, staticRenderFns } from "./seleccion_facturas_compras.vue?vue&type=template&id=5f64e687&scoped=true"
import script from "./seleccion_facturas_compras.js?vue&type=script&lang=js&external"
export * from "./seleccion_facturas_compras.js?vue&type=script&lang=js&external"
import style0 from "./seleccion_facturas_compras.css?vue&type=style&index=0&id=5f64e687&prod&scoped=true&lang=css&external"
import style1 from "./seleccion_facturas_compras.vue?vue&type=style&index=1&id=5f64e687&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f64e687",
  null
  
)

export default component.exports